import React, { useEffect, useMemo, forwardRef } from 'react';
import { normalizeData } from '~/common/tickets';
import { useAwaitControl } from 'react-redux-await-control';
import { getTicketResolutionReasons } from '~/store/tickets/actions';
import { MultiSelect } from '~/ui/components/MultiSelect/MultiSelect';

export type ReasonSelectProps = {
  value?: any;
  onChange?: (value: string | string[]) => void;
};

export const JustificationSelect = forwardRef<HTMLDivElement, ReasonSelectProps>(({ onChange, ...props }, ref) => {
  const awaitControl = useAwaitControl(getTicketResolutionReasons);
  const isLoading = awaitControl.isRunning();
  const awaitResult = awaitControl.result();

  const options = useMemo(
    () => awaitResult.filter((data) => data.enabled).map((el) => ({ id: el.id, name: el.justification })),
    [awaitResult],
  );

  const handleOnChange = (options: string[]) => {
    if (onChange) {
      onChange(options);
    }
  };

  useEffect(() => {
    if (!options?.length) {
      awaitControl.start();
    }
  }, []);

  return (
    <MultiSelect
      ref={ref}
      placeholder="Justificativa da resolução"
      loading={isLoading}
      options={normalizeData(options)}
      onChange={handleOnChange}
      searchable
      {...props}
    />
  );
});
